import React from 'react';
import { Caption, RichCell, Separator, Text } from '@vkontakte/vkui';
import { useAppContext } from '../../../AppContext';
import PropTypes from 'prop-types';
import { CreatorType, EventItemImageType } from '../../../Types';
import { ItemNameBlock } from './ItemsBlockComponent';

const RepaymentTypeComponent = ({id, comment, date, amount, to, from, users, onClick}) => {
  const context = useAppContext();
  to = users[to];
  from = users[from];

  return (<>
    <RichCell
      multiline
      caption={<>
        <Caption weight={'3'} level={'1'} className={'RepaymentRow__comment'}>{comment.length > 1 ? comment : (<>&nbsp;</>)}</Caption>
      </>}
      after={<div className={'RepaymentRow__rightBlock'}>
        <Text weight={'1'} className={'RepaymentRow__amount'}>+{context.lang().formatPrice(amount)}</Text>
        <Caption>{context.lang().dateFormatShort(date)}</Caption>
      </div>}
      actions={<ItemNameBlock title={to.name} user={to}/>}
      onClick={onClick}
    >
      <ItemNameBlock title={from.name} user={from}/>
    </RichCell>
    <Separator/>
  </>);
}

export default RepaymentTypeComponent;

RepaymentTypeComponent.propTypes = {
  id: PropTypes.number.isRequired,
  comment: PropTypes.string,
  amount: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  users: PropTypes.objectOf(CreatorType).isRequired,
  images: PropTypes.arrayOf(EventItemImageType).isRequired,
};
